var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M21.28,4.71c-.39-.39-.86-.59-1.41-.59H3.87c-.55,0-1.02.2-1.41.59s-.59.86-.59,1.41v12c0,.55.2,1.02.59,1.41.39.4.86.59,1.41.59h16c.55,0,1.02-.19,1.41-.59.39-.39.59-.86.59-1.41V6.12c0-.55-.2-1.02-.59-1.41ZM19.87,18.12H3.87v-10l8,5,8-5v10ZM11.87,11.12L3.87,6.12h16l-8,5Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }